<div>
    <div>
        <div style="display: block" *ngIf="lineChartData">
            <canvas baseChart [datasets]="lineChartData" [labels]="lineChartLabels" [chartType]="lineChartType">
        </canvas>
        </div>
    </div>
</div>